import configureStore from './configureStore'; //eslint-disable-line

const store = configureStore();

export default store;



/** WEBPACK FOOTER **
 ** ./src/store/index.js
 **/